<template>
  <div class="biz-score-picker-wrap">
    <TitleGroup v-for="(scoreGrade, index) in scoreGrades"
                :key="'grade-' + index"
                :bold="false"
                :title="scoreGrade.name">
      <div class="grade score-wrap">
        <template v-if="scoreGrade.options">
          <div class="score-items">
            <ul>
              <li v-for="(option, i) in scoreGrade.options"
                  :key="'option-' + i"
                  @click="selectScore(option.name)">
                <span :class="option | optionState(passScore)">{{option.name}}</span>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="score-scope">
            <BizScorePickerWrapScope :display-fraction="displayFraction"
                                     :min-score="minScore"
                                     :max-score="maxScore"
                                     :pass-score="passScore"
                                     @click="selectScore"></BizScorePickerWrapScope>
          </div>
        </template>
      </div>
    </TitleGroup>
    <template v-if="scoreExtras && scoreExtras.length">
      <TitleGroup title="其他"
                  :bold="false">
        <div class="extra score-wrap">
          <div class="score-items">
            <ul>
              <li v-for="(extra, index) in scoreExtras"
                  :key="'extra-' + index"
                  @click="selectScore(extra)">
                <span class="is-fail">{{extra}}</span>
              </li>
            </ul>
          </div>
        </div>
      </TitleGroup>
    </template>
  </div>
</template>

<script>
import TitleGroup from '../../../../widgets/custom/TitleGroup'
import BizScorePickerWrapScope from './scope'
import scoreGradeUtils from '../../../../../util/biz/scoreGradeUtils'
import scoreComputeUtils from '../../../../../util/biz/scoreComputeUtils'
export default {
  name: 'BizScorePickerWrap',
  components: {
    TitleGroup,
    BizScorePickerWrapScope
  },
  props: {
    scoreGrades: {
      type: Array,
      required: true
    },
    scoreExtras: Array,
    scoreAlias: Object,
    displayFraction: Boolean,
    minScore: {
      type: Number,
      default: 0
    },
    maxScore: {
      type: Number,
      default: 100
    },
    passScore: {
      type: Number,
      default: 60
    }
  },
  filters: {
    optionState (option, passScore) {
      let value = option.convert
      if (typeof value !== 'number' && !isNaN(value)) {
        value = Number(value)
      }
      if (typeof value === 'number') {
        if (value < passScore) {
          return 'is-fail'
        }
      }
    }
  },
  methods: {
    resolveScore (score) {
      let scoreGrades = this.scoreGrades
      if (isNaN(score)) {
        for (let i = 0; i < scoreGrades.length; i++) {
          const scoreGrade = scoreGrades[i]
          const option = scoreGradeUtils.getMatchOption(scoreGrade, score)
          if (option) {
            return {
              type: 'success',
              info: '选择成功',
              data: option
            }
          }
        }
        if ((this.scoreExtras || []).includes(score)) {
          return {
            type: 'success',
            info: '选择成功',
            data: {
              name: score,
              convert: this.minScore
            }
          }
        }
        const alias = Object.entries(this.scoreAlias || {}).find(([k, v]) => v === score)
        if (alias) {
          return {
            type: 'success',
            info: '选择成功',
            data: {
              name: score,
              convert: scoreComputeUtils.scoreRound(Number(alias[0]), this.displayFraction)
            }
          }
        }
        return {
          type: 'fail',
          info: '评分不合法'
        }
      } else {
        const supportDigit = scoreGrades.find(scoreGrade => !scoreGrade.options)
        if (supportDigit) {
          let rawScoreZh = Number(score)
          if (rawScoreZh >= this.minScore && rawScoreZh <= this.maxScore) {
            const scoreZh = scoreComputeUtils.scoreRound(rawScoreZh, this.displayFraction)
            if (scoreZh !== rawScoreZh) {
              return {
                type: 'fail',
                info: '分值不合法'
              }
            } else {
              return {
                type: 'success',
                info: '选择成功',
                data: {
                  name: score,
                  convert: scoreZh
                }
              }
            }
          } else {
            return {
              type: 'fail',
              info: '分值范围不合法'
            }
          }
        } else {
          return {
            type: 'fail',
            info: '不支持分值'
          }
        }
      }
    },
    selectScore (score) {
      const input = (this.scoreAlias || {})[score] || score
      this.$emit('select', input)
    }
  },
  mounted () {
    this.$nextTick(() => this.$emit('ready'))
  }
}
</script>

<style lang="scss">
  @import "../../../../../styles/color";
  .biz-score-picker-wrap {
    min-height: 80px;
    .title-group {
      & > .header {
        & > .title {
          color: #909399;
        }
      }
      & > .main {
        margin-top: 8px;
        padding-left: 0!important;
        .score-wrap {
          margin-top: 10px;
          box-shadow: inset 0 0 8px #f0f2f5;
          background-color: #fafafa;
          border: 1px solid rgba(0,0,0,.03);
          border-radius: 3px;
          box-sizing: border-box;
          .score-items {
            padding: 6px;
            ul {
              margin: 0 -1px;
              padding: unset;
              list-style: none;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              & > li {
                margin: 0 1px;
                font-size: 12px;
                font-weight: bold;
                min-width: 42px;
                text-align: center;
                line-height: 20px;
                padding: 1px 5px;
                background-color: transparent;
                border-radius: 20px;
                transition: all .3s;
                cursor: pointer;
                &:hover {
                  background-color: rgba(0,0,0,.1);
                }
                &:active {
                  background-color: rgba(0,0,0,.2);
                }
                .is-fail {
                  color: $set-danger-color!important;
                }
              }
            }
          }
        }
      }
      & + .title-group {
        margin-top: 15px;
      }
    }
  }
</style>
